import React from "react";
import BaseDefault from "../../core/BaseDefault";

export default function Error_Page(){
    return(
        <BaseDefault
            styles="title-page"
            title= "404 Page"
        >
            
        </BaseDefault>
    )
}